// noinspection JSUnusedGlobalSymbols

import {format, parse} from "date-fns";

/**
 * Helper functions for dealing with dates using date-fns
 */

const HTML_DATE_STRING_FORMAT = 'yyyy-MM-dd';
const HTML_DATETIME_STRING_FORMAT = 'yyyy-MM-dd hh:mm aa';

/**
 * @param {string} dateString
 * @return {Date}
 */
function parseHtmlDate(dateString) {
	return parse(dateString, HTML_DATE_STRING_FORMAT, new Date())
}

/**
 * @param {Date} date
 * @return {string}
 */
function formatHtmlDate(date) {
	return format(date, HTML_DATE_STRING_FORMAT)
}

/**
 * @param {string} dateString
 * @return {Date}
 */
function parseHtmlDateTime(dateString) {
	return parse(dateString, HTML_DATETIME_STRING_FORMAT, new Date())
}

/**
 * @param {Date} date
 * @return {string}
 */
function formatHtmlDateTime(date) {
	return format(date, HTML_DATETIME_STRING_FORMAT)
}

export {
	HTML_DATE_STRING_FORMAT,
	HTML_DATETIME_STRING_FORMAT,
	parseHtmlDate,
	formatHtmlDate,
	parseHtmlDateTime,
	formatHtmlDateTime
}
